function HelpCenterIcon3() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={{ marginRight: '3px' }}
    >
      <path
        opacity='0.4'
        d='M4.94995 17.2119C3.72995 15.8919 3 14.121 3 12.001C3 6.99998 7.03 4 12 4C16.97 4 21 6.99998 21 12.001C21 17.002 16.97 20.002 12 20.002C10.72 20.002 9.50991 19.8021 8.40991 19.4221C7.06991 20.8521 4.87996 21.0419 3.45996 20.9919C3.02996 20.9819 2.83992 20.4321 3.16992 20.1521C4.25992 19.2731 4.79995 18.1729 4.94995 17.2119Z'
        fill='#465364'
      />
      <path
        d='M11.9971 13.612C11.9151 13.612 11.833 13.598 11.752 13.569C11.367 13.432 11.1581 13.0229 11.2891 12.6349C11.4921 12.0339 12.0859 11.5859 12.5149 11.3019C13.1509 10.8789 13.1579 10.4499 13.1079 10.1649C13.0299 9.72394 12.6529 9.34594 12.2109 9.26894C11.8749 9.20794 11.5381 9.29484 11.2781 9.51284C11.0221 9.72784 10.876 10.0419 10.876 10.3749C10.876 10.7889 10.54 11.1249 10.126 11.1249C9.71198 11.1249 9.37598 10.7889 9.37598 10.3749C9.37598 9.5969 9.71796 8.86391 10.314 8.36391C10.91 7.86391 11.6939 7.65291 12.4709 7.79091C13.5299 7.97691 14.399 8.84593 14.585 9.90493C14.77 10.9569 14.3299 11.8959 13.3469 12.5509C12.7899 12.9199 12.7139 13.1079 12.7109 13.1149C12.5969 13.4179 12.3051 13.612 11.9971 13.612ZM13.02 15.4999C13.02 14.9479 12.573 14.4999 12.02 14.4999H12.01C11.458 14.4999 11.0149 14.9479 11.0149 15.4999C11.0149 16.0519 11.468 16.4999 12.02 16.4999C12.572 16.4999 13.02 16.0519 13.02 15.4999Z'
        fill='#465364'
      />
    </svg>
  );
}

export default HelpCenterIcon3;
